/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function VolumeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="volume"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M16 10A5.105 5.105 0 0 1 16 14" data-tinysvg-shape="arc" data-tinysvg-arc="11.303 12 5.105 5.105 336.933 383.066 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.5 8A8.656 8.656 0 0 1 18.5 16" data-tinysvg-shape="arc" data-tinysvg-arc="10.823 12 8.656 8.656 332.479 387.522 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.5 9C3.395 9 2.5 9.895 2.5 11L2.5 13C2.5 14.105 3.395 15 4.5 15L5.413 15C5.796 15 6.172 15.11 6.494 15.318L13 19.5L13 4.5L6.494 8.682C6.172 8.89 5.796 9 5.413 9L4.5 9Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
